import { Col, Form, FormInstance, Input, Row } from 'antd'
import { useContext } from 'react'
import styled from 'styled-components'

import { Plugin } from 'packages/sdks-next/growp'
import { AnyType } from 'packages/types'

import {
  SystemPluginOauthConfigItem,
  UserPluginContextParam,
} from '../../utils/type'
import {
  UserPluginContext,
  arrayChunk,
  getSystemPluginOauthConfigItems,
  handleSystemPluginConfigValue,
} from '../../utils/util'

/**
 * 编辑系统应用弹窗 - 弹窗内容 - 配置设置
 *
 * @param param - 参数
 * @param param.form - 表单
 * @param param.plugin - 插件
 * @returns 组件
 */
export const SystemPluginConfig: React.FC<{
  form: FormInstance<AnyType>
  plugin: Plugin
}> = ({ form, plugin }) => {
  const { initFormValues } =
    useContext<UserPluginContextParam>(UserPluginContext)

  const items = arrayChunk(getSystemPluginOauthConfigItems(plugin), 2)

  return (
    <Box>
      <Form
        form={form}
        layout="vertical"
        initialValues={initFormValues}
      >
        <Row>
          <SectionTitle>{'端点信息'}</SectionTitle>
        </Row>
        <Row>
          <Col span={11}>
            <Form.Item
              label="App ID"
              name={handleSystemPluginConfigValue(['config', 'clientId'])}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={1} />
          <Col span={12}>
            <Form.Item
              label="App Secret"
              name={handleSystemPluginConfigValue(['config', 'clientSecret'])}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <SectionTitle>{'登录配置'}</SectionTitle>
        </Row>
        {items.map((item, key) => {
          const firstItem = item[0] as SystemPluginOauthConfigItem
          const secondItem = item[1] as SystemPluginOauthConfigItem | undefined
          return (
            <Row key={key}>
              <Col span={11}>
                <Form.Item
                  label={firstItem.label}
                  name={handleSystemPluginConfigValue([
                    'config',
                    firstItem.name,
                  ])}
                  rules={firstItem.rules}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={1} />
              <Col span={12}>
                {secondItem === undefined ? null : (
                  <Form.Item
                    label={secondItem.label}
                    name={handleSystemPluginConfigValue([
                      'config',
                      secondItem.name,
                    ])}
                    rules={secondItem.rules}
                  >
                    <Input />
                  </Form.Item>
                )}
              </Col>
            </Row>
          )
        })}
      </Form>
    </Box>
  )
}

const Box = styled.div`
  width: 100%;
`

const SectionTitle = styled.div`
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  height: 28px;
  color: ${(props) => props.theme.text._1};
  margin-bottom: 20px;
`
